export default function addUserNameToNavBar(user) {
    var userName = document.querySelectorAll(".js-user");
    userName.forEach(function (element) {
        element.innerHTML = "<i class=\"fas fa-user\"></i> &nbsp " + user;
    });
}
